<template>
  <div class="container container-reports reports">
    <el-header height="auto">
      <breadcrumb crumb="reports" />
      <header-report @search="newSearch" />
    </el-header>
    <el-main>
      <header-list />
      <loader-wrapper :loading="loaded">
        <div v-if="reports.length">
          <body-list :reports="reports" />
          <div class="pagination">
            <pagination-custom :data="pagination" @changed="changePage" />
          </div>
        </div>

        <div v-else class="no-reports-container">Отчетов нет</div>
      </loader-wrapper>
    </el-main>
  </div>
</template>

<script>
import { FETCH_REPORTS } from '@/store/actions/reports'
import { mapActions, mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import HeaderReport from '@/views/Reports/Components/Header/Header'

import BodyList from '@/views/Reports/Components/List/Body'
import HeaderList from '@/views/Reports/Components/List/Header'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import PaginationCustom from '@/components/Tables/PaginationCustom'

export default {
  name: 'Reports',
  components: {
    Breadcrumb,
    HeaderReport,
    LoaderWrapper,
    HeaderList,
    BodyList,
    PaginationCustom,
  },
  data() {
    return {
      curPage: 1,
      curSearch: {},
    }
  },
  computed: {
    ...mapGetters({
      reports: 'reports/getReports',
      loaded: 'reports/getLoadedReports',
      pagination: 'reports/getPagination',
    }),
  },
  mounted() {
    this.getReports()
  },
  methods: {
    ...mapActions({ fetchReports: `reports/${FETCH_REPORTS}` }),
    changePage(page = 1) {
      this.curPage = page
      this.getReports()
    },
    newSearch(searchData = null) {
      this.curPage = 1
      this.curSearch = {}
      if (searchData) {
        for (let key in searchData) {
          if (searchData[key] && (searchData[key].length || !isNaN(searchData[key]))) {
            this.curSearch[key] = searchData[key]
          }
        }
      }
      this.getReports()
    },
    getReports() {
      this.curSearch.page = this.curPage
      this.fetchReports(this.curSearch)
    },
  },
}
</script>

<style lang="sass">
.el-main
  min-height: 200px
.no-reports-container
  margin-top: 40px
  text-align: center
  font-weight: bold
</style>
